import { PermissaoUsuario } from './permissao-usuario';
import { Consulta } from './consulta';

export class UsuarioUnidade {
  acessoConsultaEspecial: boolean;
  somenteVisualizacao: boolean;
  exibirConsultaAvulsa: boolean;
  editarLaudo: boolean;
  administrador: boolean;
  acessoTodasConsultas: boolean;
  nome: string;
  email: string;
  login: string;
  senha: string;
  listaPermissao = [];
  listaConsultas = [];
  listaConsultasCombinadas = [];
  status: boolean;
  uuid: string;

  constructor(u: any = []) {
    this.acessoConsultaEspecial = u['acessoConsultaEspecial'] || false;
    this.somenteVisualizacao = u['somenteVisualizacao'] || false;
    this.exibirConsultaAvulsa = u['exibirConsultaAvulsa'] || false;
    this.editarLaudo = u['editarLaudo'] || false;
    this.administrador = u['administrador'] || false;
    this.acessoTodasConsultas = u['acessoTodasConsultas'] || false;
    this.nome = u['nome'] || '';
    this.email = u['email'] || '';
    this.login = u['login'] || '';
    this.senha = u['senha'] || '';
    this.status = u['status'] || false;
    this.uuid = u['uuid'] || null;
    this.listaPermissao = u['listaPermissao'] ? u['listaPermissao'].map(p => new PermissaoUsuario(p)) : [];
    this.listaConsultas = u['listaConsultas'] ? u['listaConsultas'].map(c => new Consulta(c)) : [];
    this.listaConsultasCombinadas = u['listaConsultasCombinadas'] ? u['listaConsultasCombinadas'].map(r => new Consulta(r)) : [];
  }
}
